import script from "./TranscriptContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptContent.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptContent.vue?vue&type=style&index=0&id=09dc156b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09dc156b"]])

export default __exports__